import { useQuery } from '@tanstack/react-query';

import { api } from './api.ts';

export interface NotificationItem {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  /** Path inside the app. */
  link: string | null;
  read: boolean;
  createdAt: string;
}

export const NOTIFICATIONS_KEY = ['notifications'] as const;

/** The bell: refreshed every minute and when the window regains focus. */
export function useNotifications() {
  return useQuery({
    queryKey: NOTIFICATIONS_KEY,
    queryFn: () => api<{ unread: number; items: NotificationItem[] }>('/notifications'),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
